new Glide('.home_glide', {
  type: 'slider',
  startAt: 0,
  autoplay: 3000,
  hoverpause: true,
  perView: 1,
}).mount();
new Glide('.home_collaborations', {
  type: 'carousel',
  startAt: 0,
  hoverpause: true,
  perView: 5,
  breakpoints: {
    800: {
      perView: 4
    },
    600: {
      perView: 2
    },
    300: {
      perView: 2
    }
  } 
}).mount();
new Glide('.test_slider', {
  type: 'slider',
  startAt: 0,
//   autoplay: 3000,
  hoverpause: true,
  perView: 1,
}).mount();
// new Glider(document.querySelector('.test_slider'), { slidesToShow: 1,slidesToScroll: 1,dots: '.test_dots',draggable: true,arrows: {prev: '.tglider-prev',next: '.tglider-next'} });
      
      
      